module.exports = __webpack_public_path__ + "/login_ui/img/sx-c2970bc4b70396232520d65c649f6adc.svg";